import React from 'react'
import {Lookup} from "@redriver/cinnamon";

const NonPropagatingLookup = (props) => {
    return (
        <Lookup {...props} onKeyDown={(e) => e.stopPropagation()} />
    )
}
export default NonPropagatingLookup
